import React from "react";

const ApcCard = ({
  heading,
  isIndian,
  ApcPrice,
  Discount,
  IntroPrice,
  IntroGrant,
  finalPrice,
  pageName,
  days,
  DiscountTitle = "Discount"
}) => {
  return (
    <div
      className="col-lg-7 col-md-10 article_col_box px-lg-0 px-3 customapccard"
      style={{
        maxWidth: "600px",
        width: "100%",
        boxShadow: "0px 0px 6px rgba(254, 134, 0, 0.3)",
        borderRadius: "28px",
        border: "1px solid #FFE4CC",
        overflow: "hidden",
        background: "#ffffff"
      }}
    >
      <div className="row mx-0">
        <div
          className="col-lg-12 py-3 mb-3 px-5 customHeadapccard backgroudAPCCharge"

        >
          <div className="top_title text-center tagh4">
            <h4 className="text-white">
              {" "}
              {heading}{" "}
            </h4>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center px-2 px-md-3 py-2">
          <div className="article-table-title article customarticleapccard-processing">
            <p className="tagp mb-0" style={{ fontSize: "18px", whiteSpace: "nowrap" }}>
              Article Processing Charge
            </p>
          </div>
          <div className="article-table-data article text-end">
            <p className="tagp mb-0" style={{ fontSize: "18px", whiteSpace: "nowrap" }}>
              {Discount ? <s>{ApcPrice}</s> : ApcPrice}
            </p>
          </div>
        </div>
        {Discount && (
          <div className="d-flex justify-content-between align-items-center px-3 px-md-4 py-2">
            <div className="article-table-title article customarticleapccard-introductory">
              <p className="tagp mb-0">
                {DiscountTitle}
              </p>
            </div>
            <div className="article-table-data article customarticleapccard-introductory text-end">
              <p className="tagp mb-0">
                {Discount}
              </p>
            </div>
          </div>
        )}
        {finalPrice && (
          <div className="d-flex justify-content-between align-items-center px-3 px-md-4 py-2 mt-3 mb-2">
            <div className="article-table-title article">
              <h5 className="tagh5 mb-0">Final Price</h5>
            </div>
            <div className="article-table-data article text-end">
              <h5 className="price tagh5 mb-0">{finalPrice}</h5>
            </div>
          </div>
        )}
        {pageName != "homepage" && (
          <>
            {isIndian ? (
              <>
                <div className="row m-0 px-4">
                  <p
                    className="pt-1 customapccardimpinfo tagp"
                  >
                    <strong>Important Information:</strong>
                  </p>
                </div>

                <div className="row m-0 px-4">
                  <ul className="tagul underList">
                    <li className="tagli">
                      <span className="red-dit">*</span>We aspire to publish an article within 15 days subject to Author implementing changes detailed by journal editors.

                    </li>
                    <li className="tagli">
                      <span className="red-dit">*</span>This APC is subject to changes at the discretion of the platform.
                    </li>
                    <li className="tagli">
                      <span className="red-dit">*</span>The APC is charged ONLY for accepted articles, and before publishing.
                    </li>


                    <li className="tagli">

                    </li>
                  </ul>
                </div>
              </>
            ) : (
              <>

                <div className="row m-0 px-4 customapccardimpinfo">
                  <ul className="tagul underList">
                    <li className="tagli">
                      <span className="red-dit">*</span>We aspire to publish an article within 15 days subject to Author implementing changes detailed by journal editors.
                    </li>
                    <li className="tagli">
                      <span className="red-dit">*</span>This APC is subject to changes at the discretion of the platform
                    </li>
                    <li className="tagli">
                      <span className="red-dit">*</span>The APC is charged ONLY for accepted articles, and before publishing
                    </li>
                    <li className="tagli">

                    </li>
                  </ul>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <div className="col-lg-4"></div>
    </div>
  );
};

export default ApcCard;
